import { useCallback } from 'preact/compat';

type InitFunction = (scope: ParentNode) => void;

/* Callback ref, not useRef + useEffect: a component that returns a loading or
   empty state first mounts its controls on a later render, and by then a
   [initFn]-deps effect has long since run against a null ref — leaving the
   control unwired (a dropdown whose panel never gets `hidden` is stuck open).
   A callback ref fires whenever the node actually attaches. */
export function useFormControl<T extends HTMLElement = HTMLDivElement>(initFn: InitFunction) {
  return useCallback(
    (node: T | null) => {
      if (node) initFn(node);
    },
    [initFn],
  );
}
